import React, { useState } from "react";
import Breadcrumbs from "../layout/breadcrumb";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "./quality.css";
import NCR from "./ncr";
import SOP from "./sop";
import Checklist from "./checklist";
import DprHeader from "../layout/dprHeader";
import { useLocation } from "react-router-dom";

export default function Quality() {
  const location = useLocation();
  const data = location.state || {};
  return (
    <div className="pb-5">
      <Breadcrumbs title="Quality Form" menu="Quality Form" link="" />
      <DprHeader project={data} />
      <div className="row mt-3">
        <Tabs>
          <div className="card pt-2">
            <div className="row">
              <div className="col-4" style={{ marginLeft: "5px" }}>
                <TabList>
                  <Tab>NCR</Tab>
                  <Tab>SOP</Tab>
                  <Tab>Checklist</Tab>
                </TabList>
              </div>
            </div>
          </div>
          {/* <div className="card"> */}
          <div className="row">
            <TabPanel>
              <NCR project={data} />
            </TabPanel>
            <TabPanel>
              <SOP project={data} />
            </TabPanel>
            <TabPanel>
              <Checklist project={data} />
            </TabPanel>
          </div>
          {/* </div> */}
        </Tabs>
      </div>
    </div>
  );
}
